import { useMutation } from "@apollo/client/react"
import { useState } from "react"
import { toast } from "sonner"
import { gql } from "~/__generated__"
import { useViewer } from "~/auth/use-viewer"
import { directImageUpload } from "~/common/direct-image-upload"
import { PhotoDropzone } from "~/ui/photo-dropzone"

const viewerUpdateAvatarMutation = gql(/* GraphQL */ `
  mutation ViewerUpdate($input: ViewerUpdateInput!) {
    viewerUpdate(input: $input) {
      user {
        id
        avatarThumbUrl
      }
    }
  }
`)

export const AvatarUpload = () => {
  const [isSaving, setIsSaving] = useState(false)
  const [localFile, setLocalFile] = useState<File | null>(null)
  const { viewer } = useViewer()

  const [runViewerUpdate] = useMutation(viewerUpdateAvatarMutation)

  const onFileSelected = async (file: File) => {
    setLocalFile(file)
    setIsSaving(true)
    try {
      const { signedId } = await directImageUpload(file)
      const { error } = await runViewerUpdate({
        variables: { input: { viewerInput: {}, avatarSignedId: signedId } },
      })
      if (error) toast.error("Failed to save avatar")
    } catch {
      toast.error("Photo upload failed")
    } finally {
      setIsSaving(false)
    }
  }

  const removeAvatar = async () => {
    try {
      const { error } = await runViewerUpdate({
        variables: { input: { viewerInput: {}, removeAvatar: true } },
      })
      if (error) {
        toast.error("Failed to remove avatar")
      } else {
        setLocalFile(null)
      }
    } catch {
      toast.error("Error removing avatar")
    }
  }

  const hasAvatar = localFile != null || viewer.avatarThumbUrl != null

  return (
    <div>
      <PhotoDropzone
        shape="circle"
        file={localFile}
        initialUrl={viewer.avatarThumbUrl ?? null}
        onFileSelected={onFileSelected}
        onRemove={hasAvatar ? removeAvatar : undefined}
        disabled={isSaving}
        label="Profile photo"
      />
      {isSaving ? <p className="mt-2 text-sm text-stone-500">Saving…</p> : null}
    </div>
  )
}
